<template>
    <div>
        <el-input-number
            v-if="mode === 'edit'"
            :ref="reference"
            v-model="localValue.numericValue"
            :min="parseInt(prop.min)"
            :max="parseInt(prop.max)"
            :controls="false"
        >
        </el-input-number>
        <p v-else>
            {{ numericDisplay }}
        </p>
    </div>
</template>
<script>
import CfMixin from '../../../mixins/CustomfieldInputsMixins';
import { deepEqual } from 'Helpers/deepEqual';

export default {
    mixins: [CfMixin],
    emits: ['update:modelValue'],

    data() {
        return {
            localValue: this.value,
        };
    },
    computed: {
        numericDisplay() {
            if (this.localValue.numericValue == null || this.localValue.numericValue == undefined) {
                return '';
            } else {
                return this.localValue.numericValue;
            }
        },
    },
    watch: {
        localValue: {
            handler: function (newValue, oldValue) {
                if (!deepEqual(newValue, oldValue)) {
                    if (this.checkParams(newValue)) this.$emit('update:modelValue', newValue);
                }
            },
            deep: true,
        },
        value: {
            handler: function (newValue, oldValue) {
                if (!deepEqual(newValue, oldValue)) {
                    this.localValue = newValue;
                }
            },
            deep: true,
        },
    },
    created() {
        if (this.localValue) {
            this.localValue.numericValue = this.value
                ? parseInt(this.value.numericValue)
                : prop.min != ''
                  ? prop.min
                  : 0;
        } else {
            this.localValue = this.templateData;
            this.localValue.numericValue =
                this.prop.defaultValue != '' ? parseInt(this.prop.defaultValue) : undefined;
        }
    },
    methods: {
        checkParams(newValue) {
            return this.checkMinMaxParams(newValue);
        },
    },
};
</script>
